import { useState, useEffect } from "react";

export const useUserLocation = () => {
  const [paymentGateway, setPaymentGateway] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await fetch(`https://ipinfo.io/json?token=${process.env.REACT_APP_IP_INFO_API_KEY}`);
        const data = await response.json();

        if (data?.continent_code === "AF") {
          setPaymentGateway("paystack");
        } else {
          setPaymentGateway("stripe");
        }
      } catch (err) {
        setError("Failed to fetch location");
      } finally {
        setLoading(false);
      }
    };

    fetchLocation();
  }, []);

  return { paymentGateway, loading, error };
};
